<template>
  <main-layout wide>
    <GroupDetailContainer />
  </main-layout>
</template>

<script>
import GroupDetailContainer from '@/components/Widgets/GroupDetailContainer';

export default {
  name: 'AssociateGroupsShow',
  components: {
    GroupDetailContainer,
  },
};
</script>

<style lang="scss" scoped>
</style>
